import { Alert } from "@mui/material";

const AlertComponent = ({ severity = "success", msg }) => {
  return <Alert severity={severity}>{msg}</Alert>;
};

export default AlertComponent;
